// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-checkbox-label[data-v-13f9f6b6] .custom-control-label{margin-top:2px!important}#calc-mode[data-v-13f9f6b6]>*{margin:8px 0!important}#calc-mode[data-v-13f9f6b6] .custom-control-label{margin-top:-1px!important}", ""]);
// Exports
module.exports = exports;
